var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('footer', {
    staticClass: "footer py-60 py-lg-90"
  }, [_c('v-container', [_c('v-row', [_c('v-col', {
    staticClass: "d-flex flex-column justify-space-between mb-20 mb-lg-0",
    attrs: {
      "cols": "12",
      "lg": "7"
    }
  }, [_c('div', {
    staticClass: "footer-logo mb-20 mb-lg-0"
  }), _c('p', [_vm._v("Copyright 2022. KIE SYSTEMS CO.,LTD. all rights reserced.")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "5"
    }
  }, [_c('ul', {
    staticClass: "footer-info pl-lg-60"
  }, [_c('li', {
    staticClass: "d-flex align-center mb-12 mb-lg-24"
  }, [_c('i', {
    staticClass: "icon icon-mail mr-12 mr-lg-24"
  }), _c('p', [_vm._v("info@kiesys.co.kr")])]), _c('li', {
    staticClass: "d-flex align-center mb-12 mb-lg-24"
  }, [_c('i', {
    staticClass: "icon icon-tel mr-12 mr-lg-24"
  }), _c('p', [_vm._v("+82-(0)31-906-9053/9054")])]), _c('li', {
    staticClass: "d-flex align-center mb-12 mb-lg-24"
  }, [_c('i', {
    staticClass: "icon icon-fax mr-12 mr-lg-24"
  }), _c('p', [_vm._v("+82-(0)31-624-4035")])]), _c('li', {
    staticClass: "d-flex align-center"
  }, [_c('router-link', {
    staticClass: "d-flex align-center",
    attrs: {
      "to": "/ko/aboutus/location/paju"
    }
  }, [_c('i', {
    staticClass: "icon icon-place mr-12 mr-lg-24"
  }), _c('p', [_vm._v("(10880) 대한민국 경기도 파주시 교하로 863번길 17")])])], 1)])])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }